export default __webpack_public_path__ + "static/media/LogoSecondaryWhite.0a1bf4d1.png";